export function getRequiredInputElementWidth(inputText: string, styles: {[key: string]: unknown} = {}): number {
    const pre = document.createElement("pre");
    document.body.appendChild(pre);
    pre.innerHTML = inputText;
    pre.className = "MuiInputBase-root";
    pre.style.visibility = "hidden";
    pre.style.display = "inline-block";
    Object.assign(pre.style, styles);
    // Also add 1 px so fractional clientWidth (eg 246.28px) will be rounded up instead of truncated.
    const width = pre.clientWidth + 1;
    document.body.removeChild(pre);

    return width;
}

export const getDocumentRetryKey = (documentUid: string) => `${documentUid}_retry_count`;
